<template>
    <div class="board_top_area">
        <button class="notion_button" v-if="notion" @click="outerLink(notion)">
            <img src="@/assets/ic-notion.png" alt="" />
            노션 바로가기
        </button>
        <div class="total_post" v-else>
            <span>TOTAL. </span>
            <span class="num">{{ data.totalCnt > data.list.length ? data.totalCnt : data.list.length }}</span>
        </div>
        <div class="search_filter" v-show="!data.fss">
            <div class="filter">
                <select ref="filter">
                    <option value="all">전체</option>
                    <option value="subject">제목</option>
                    <option value="contents">내용</option>
                    <option v-if="this.$route.name === 'faqFaqPage'" value="hashtag">태그</option>
                </select>
            </div>
            <form class="search" @submit="handleSearch">
                <input type="text" placeholder="검색어를 입력하세요" ref="keyword" />
                <button type="submit"></button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            default: [],
        },
        notion: {
            dafault: false,
        },
    },
    mounted() {
        if (this.$route.query.searchType) this.$refs.filter.value = this.$route.query.searchType;
        // if (this.$route.query.keyword) this.$refs.keyword.value = this.$route.query.keyword;
    },
    methods: {
        handleSearch(e) {
            e.preventDefault();

            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: 1,
                    searchType: this.$refs.filter.value,
                    keyword: this.$refs.keyword.value,
                },
            });
        },
        outerLink(link) {
            window.open(link, '_blank');
        },
    },
};
</script>
